/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiPolicyQueryResponse, GetApiPolicyQueryParams, GetApiPolicy400, GetApiPolicy401, GetApiPolicy403, GetApiPolicy404, GetApiPolicy500 } from "../../types/GetApiPolicy.ts";
import { getApiPolicyQueryResponseSchema } from "../../zod/PolicySchemas/getApiPolicySchema.ts";

function getGetApiPolicyUrl() {
  const res = { method: 'GET', url: `/api/policy` as const }  
  return res
}

/**
 * @summary Получить политику
 * {@link /api/policy}
 */
export async function getApiPolicy({ params }: { params: GetApiPolicyQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiPolicyQueryResponse, ResponseErrorConfig<GetApiPolicy400 | GetApiPolicy401 | GetApiPolicy403 | GetApiPolicy404 | GetApiPolicy500>, unknown>({ method : "GET", url : getGetApiPolicyUrl().url.toString(), params, ... requestConfig })  
  return getApiPolicyQueryResponseSchema.parse(res.data)
}